import { CURRENCY_LIST } from 'config/constants'
import { useCallback } from 'react'
import { useSelector } from 'react-redux'
import { formatNumberToMillions, formatNumberToCommas } from 'utils/formatBalance'

export const useFormatCurrency = () => {
  const { currencyConverter } = useSelector((state: any) => state.balances)
  const { currencyApp } = useSelector((state: any) => state.app)

  const getFormatCurrency = useCallback(
    (number: any, currency = currencyApp): any => {
      const currencyFormat = CURRENCY_LIST.filter((x) => x.flag === currency)
      let numberFormat = number

      if (currency === 'VN') {
        numberFormat = +numberFormat * +currencyConverter?.VND?.value
      }

      if (currency === 'BG') {
        numberFormat = +numberFormat * +currencyConverter?.EUR?.value
      }

      return `${currencyFormat[0].symbol}${formatNumberToMillions(numberFormat)}`
    },
    [currencyApp, currencyConverter],
  )
  const getFormatCurrencyToCommas = useCallback(
    (number: any, currency = currencyApp): any => {
      const currencyFormat = CURRENCY_LIST.filter((x) => x.flag === currency)
      let numberFormat = number

      if (currency === 'VN') {
        numberFormat = +numberFormat * +currencyConverter?.VND?.value
      }

      if (currency === 'BG') {
        numberFormat = +numberFormat * +currencyConverter?.EUR?.value
      }
      if (typeof numberFormat === 'number') {
        return `${currencyFormat[0].symbol}${formatNumberToCommas(numberFormat.toFixed(3))}`
      }
      return 0
    },
    [currencyApp, currencyConverter],
  )

  return [getFormatCurrency, getFormatCurrencyToCommas]
}
